var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('div',{class:[
        'panel__header position--relative display--flex',
        _vm.headerClass
    ]},[_vm._t("panel__header"),(_vm.close.show)?_c('button-with-icon',{staticClass:"panel__header__close position--absolute",attrs:{"icon":{
                component: function () { return import( /* webpackChunkName: 'IconCloseBig' */ '@/components/bundles/layout/images/icons/IconCloseBig' ); }
            },"action":{
                execute: true,
                function: _vm.close.action
            }}}):_vm._e()],2),(_vm.data.contactRequest.warnings && _vm.data.contactRequest.warnings.taxpayerIdentificationNumber)?_c('warning-bar',{staticClass:"gocc__warning",attrs:{"settings":{
            status: 'insuccess',
            message: _vm.data.contactRequest.warnings.taxpayerIdentificationNumber
        }}}):_vm._e(),_c('div',{staticClass:"panel--grid display--grid"},[_c('accordion',_vm._b({staticClass:"panel__card"},'accordion',Object.assign({}, ( _vm.data.contactRequest && {
                    contact: {
                        person: _vm.data.contactRequest.internalPersonProfile,
                        request: _vm.data.contactRequest.request,
                        requestObservations: _vm.data.contactRequest.observations,
                        internalObservations: _vm.data.contactRequest.internalObservations,
                        receptionDate: _vm.data.contactRequest.receptionDate,
                        callHistory: _vm.data.contactRequest.callHistory
                            ? _vm.data.contactRequest.callHistory
                            : _vm.data.contactRequest.contactCallHistory
                    }
                }),
                _vm.allowFilling),false)),_c('base-script',_vm._b({staticClass:"panel__card"},'base-script',Object.assign({}, {script: _vm.data.script},
                _vm.allowFilling,
                ( !_vm.specificData.isOperateMenu && {
                    isOperateMenu: _vm.specificData.isOperateMenu
                })),false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }